import { cn } from "@/lib/utils";

interface CardProps {
  children: React.ReactNode;
  className?: string;
  /** Add a subtle gradient border around the card */
  bordered?: boolean;
  /** Make the card glow on hover with a purple shadow */
  hoverable?: boolean;
}

export default function Card({ children, className, bordered = false, hoverable = false }: CardProps) {
  return (
    <div
      className={cn(
        "rounded-xl bg-bg-card p-6",
        bordered && "gradient-border",
        hoverable && "transition-shadow duration-300 hover:shadow-md",
        className,
      )}
    >
      {children}
    </div>
  );
}
